import React from "react";

import SteppedSelect from "../ReusableComponents/SteppedSelect";
import { formatIssueTime } from "../../utils/composedForecastUtils";
import type { ForecastIssue } from "../../utils/composedForecastUtils";

interface ForecastIssuePickerProps {
  issues: ForecastIssue[]; // newest first
  index: number;
  onChange: (index: number) => void;
}

/** "Date Issued" — step back through older forecast issues, as on the V1 processed-model results. */
const ForecastIssuePicker: React.FC<ForecastIssuePickerProps> = ({ issues, index, onChange }) => (
  <SteppedSelect
    options={issues.map((issue, i) => ({ value: i, label: formatIssueTime(issue.forecastIssued) }))}
    index={index}
    onChange={onChange}
    olderLabel="Older forecast"
    newerLabel="Newer forecast"
  />
);

export default ForecastIssuePicker;
